

import node from '../assets/node.png';

import react from '../assets/react.png';
import firebase from '../assets/firebase.svg'
import sass from '../assets/sass.png';
import js from "../assets/js.png";

import profile from '../assets/profile.png';
import circle from '../assets/circle.svg';
import logo from '../assets/logo.png';

const exports = {
  
    node,
  
    react,
    firebase,
    sass,
    js,
  
    profile,
    circle,
    logo,
  };

export default exports;